import { Tooltip } from '@heroui/react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ENV_BADGE_KIND, FIREBASE_PROJECT_ID } from '@/utils/appEnvironment';

import { EnvPill } from './EnvBadge.styled';

const BADGE_TEXT = { local: 'LOCALHOST', dev: 'DEV', test: 'TEST' } as const;
// Wersja na telefon (< 640 px), pełna nazwa jest w aria-label i tooltipie.
const BADGE_TEXT_SHORT = { local: 'LOCAL', dev: 'DEV', test: 'TEST' } as const;

// Plakietka środowiska w pasku górnym. Na produkcji (i gdy środowiska nie da się ustalić) nic nie renderuje.
// tabIndex, żeby tooltip z pełną nazwą był dostępny z klawiatury; na dotyku tooltip się nie pokazuje (świadomie).
export const EnvBadge: FC = () => {
  const { t } = useTranslation();

  if (!ENV_BADGE_KIND) return null;

  const projectId = FIREBASE_PROJECT_ID || '?';
  const label = {
    local: t('layout.envBadge.local', 'Lokalnie, projekt: {{projectId}}', { projectId }),
    dev: t('layout.envBadge.dev', 'Środowisko deweloperskie'),
    test: t('layout.envBadge.test', 'Środowisko testowe'),
  }[ENV_BADGE_KIND];

  return (
    <Tooltip content={label} placement="bottom" delay={300} closeDelay={0}>
      <EnvPill $kind={ENV_BADGE_KIND} aria-label={label} tabIndex={0}>
        <span className="env-full" aria-hidden="true">{BADGE_TEXT[ENV_BADGE_KIND]}</span>
        <span className="env-short" aria-hidden="true">{BADGE_TEXT_SHORT[ENV_BADGE_KIND]}</span>
      </EnvPill>
    </Tooltip>
  );
};
